export default __webpack_public_path__ + "static/hedge-trimming-b436b20abe348d3afdebeb161f7007f5.webp";